export { PromotionBadge } from './PromotionBadge';
export type { PromotionBadgeProps } from './PromotionBadge';
